import React, { FC } from 'react'
import Button from '../Button/Button'
import { PreSplashPageStyle } from './PreSplashPageStyle'

export interface PreSplashPageProps {
  buttonText: string
  onClick: () => void
}

export const PreSplashPage: FC<PreSplashPageProps> = ({
  buttonText,
  onClick,
}) => {
  return (
    <PreSplashPageStyle>
      <h1>Interactive Experiment Instructions</h1>
      <div>
        <p>
          Imagine that you are interested in opening a new current account. You
          visit a price comparison website to explore the available current
          accounts.
        </p>
        <p>
          Please read through the information carefully and choose the current
          account that appeals to you most. In reality, when you selected a
          current account deal from a price comparison website, you will be
          taken to the current account provider’s website to complete your
          application, which will normally involve providing personal
          information. However, for the purpose of research, you will not be
          tasked to provide any sensitive information.
        </p>
        <p>
          Complete the ‘shopping’ task as you normally would when searching for
          a new financial product on a price comparison website and make choices
          based on your usual requirements.
        </p>
        <p>Please click ‘Continue’ when you are ready to begin the task.</p>
      </div>
      <Button onClick={onClick}>{buttonText}</Button>
    </PreSplashPageStyle>
  )
}
